import { Component, OnInit, EventEmitter, Inject } from '@angular/core';
import {  MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  onChange = new EventEmitter();
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      dialogRef.disableClose = true;
     }

  onNoClick(): void {
    this.dialogRef.close();
    this.onChange.emit("cancel");
  }

  ngOnInit(): void {
  }

  confirm(): void {
    this.onChange.emit("confirm");
  }
}
